import React from 'react';
import DefaultTemplate from 'layouts/Default';
import RegistrationTemplate from './Registration/Registration';
import SignInTemplate from './SignIn/SignIn';
import PanelTemplate from './Panel/Panel';
import PanelWithoutContainerTemplate from './PanelWithoutContainer/PanelWithoutContainer';
import FirmsTemplate from './Firms/Firms';
import TriageTemplate from './Triage/Triage';
import ProfileTemplate from './Profile/Profile';

export enum Layouts {
  DEFAULT = 'default',
  REGISTRATION = 'registration',
  SIGN_IN = 'signIn',
  PANEL = 'panel',
  PANEL_WITHOUT_CONTAINER = 'panelWithoutContainer',
  FIRMS = 'firms',
  TRIAGE = 'triage',
  PROFILE = 'profile',
}

export interface PageLayoutParams {
  layout: Layouts;
}

export const getLayoutFromComponent = (component: React.FC | PageLayoutParams | undefined) => {
  return component && 'layout' in component ? component.layout : Layouts.DEFAULT;
};

export const LayoutProvider: React.FC<{ layout?: Layouts }> = ({ children, layout }) => {
  if (layout === Layouts.REGISTRATION) {
    return <RegistrationTemplate>{children}</RegistrationTemplate>;
  }

  if (layout === Layouts.SIGN_IN) {
    return <SignInTemplate>{children}</SignInTemplate>;
  }

  if (layout === Layouts.TRIAGE) {
    return <TriageTemplate>{children}</TriageTemplate>;
  }

  if (layout === Layouts.PANEL) {
    return <PanelTemplate>{children}</PanelTemplate>;
  }

  if (layout === Layouts.PANEL_WITHOUT_CONTAINER) {
    return <PanelWithoutContainerTemplate>{children}</PanelWithoutContainerTemplate>;
  }

  if (layout === Layouts.FIRMS) {
    return <FirmsTemplate>{children}</FirmsTemplate>;
  }

  if (layout === Layouts.PROFILE) {
    return <ProfileTemplate>{children}</ProfileTemplate>;
  }

  return <DefaultTemplate>{children}</DefaultTemplate>;
};
